import styled from 'styled-components';

import mediaQueries from 'theme/mediaQueries';
import { borderRadius, color } from 'theme/selectors';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
    gap: 4px;
`;

export const DayButton = styled.button<{ $isSelected: boolean; $isToday: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 50px;
    height: 50px;
    border: none;
    cursor: pointer;
    border-radius: ${borderRadius('small')};
    color: ${color('text-main')};
    background: ${({ $isSelected, $isToday, theme }) => {
        if ($isSelected) return theme['primary-default'];
        if ($isToday) return theme['surface-selected'];

        return 'transparent';
    }};

    ${mediaQueries.laptop} {
        width: 64px;
        height: 64px;

        &:hover {
            background: ${color('primary-hovered')};
        }
    }

    &:active {
        background: ${color('primary-active')};
    }
`;

export const DayLabel = styled.span`
    font-size: 12px;

    ${mediaQueries.laptop} {
        font-size: 14px;
    }
`;

export const DayNumber = styled.span`
    font-size: 14px;
    font-weight: 700;

    ${mediaQueries.laptop} {
        font-size: 18px;
    }
`;
